import { GET_TOC_CONTACTS } from '../../../../models/table-of-contents/queries.gql';
import { SLUG } from '../../../../models/table-of-contents/constants';
import useGetAllPlaceholders from '../../../../components/offers/logic/use-get-all-placeholders';
import useTableOfContents from '../../../../cms/utils/use-table-of-contents';

/**
 * This hook essentially kicks off the contacts related sanity calls to ensure the
 * Apollo cache is populated before the customer gets to the point in the decision tree
 * where contact details need to be shown.
 */
const useContacts = () => {
  useGetAllPlaceholders();
  useTableOfContents({
    query: GET_TOC_CONTACTS,
    skip: false,
    slug: SLUG.LOOKING_TO_JOIN_CONTACTS,
    typename: 'Contact',
  });
  useTableOfContents({
    query: GET_TOC_CONTACTS,
    skip: false,
    slug: SLUG.CURRENT_MEMBER_CONTACTS,
    typename: 'Contact',
  });
};

export default useContacts;
